<header class="app-top-bar-2">
  <div *ngIf="isVisible" class="topbar-toast" [ngClass]="currentClass">
    <span [class]="messageTextClass" style="font-size: 16px !important">
      &nbsp;
      <i [class]="icon"></i>
      &nbsp;
      <b> {{ currentMessage }} </b>&nbsp;&nbsp;
      <a
        *ngIf="path"
        (click)="handlerGo()"
        style="cursor: pointer; text-decoration: none;"
      >
        Go
      </a>
      <a *ngIf="reload" (click)="handlerReload()" class="reload-link"> Reload </a>
    </span>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button
      type="button"
      class="btn-close me-2 m-auto"
      aria-label="Close"
      (click)="closeToast()"
    ></button>
  </div>

  <app-welcome-box />

  <app-portal-top-nav
    class="top-bar-2-nav"
    [active]="activeTab"
    [showPatientOutcomes]="hasPatientOutcomesPermission"
    (dashboardClick)="goToDashboard()"
    (patientOutcomesClick)="goToPatientOutcomes()"
    (referralsClick)="goToReferrals()"
    (complianceClick)="goToCompliance()"
  />

  <div class="mobile-group">
    <div class="profile-group">
      <!-- <div class="dashboard-container">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17657_21429)">
            <path
              d="M4.16665 3.33325H7.49998C7.72099 3.33325 7.93295 3.42105 8.08924 3.57733C8.24552 3.73361 8.33331 3.94557 8.33331 4.16659V9.16659C8.33331 9.3876 8.24552 9.59956 8.08924 9.75584C7.93295 9.91212 7.72099 9.99992 7.49998 9.99992H4.16665C3.94563 9.99992 3.73367 9.91212 3.57739 9.75584C3.42111 9.59956 3.33331 9.3876 3.33331 9.16659V4.16659C3.33331 3.94557 3.42111 3.73361 3.57739 3.57733C3.73367 3.42105 3.94563 3.33325 4.16665 3.33325Z"
              stroke="#4DC3BD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.16665 13.3333H7.49998C7.72099 13.3333 7.93295 13.421 8.08924 13.5773C8.24552 13.7336 8.33331 13.9456 8.33331 14.1666V15.8333C8.33331 16.0543 8.24552 16.2662 8.08924 16.4225C7.93295 16.5788 7.72099 16.6666 7.49998 16.6666H4.16665C3.94563 16.6666 3.73367 16.5788 3.57739 16.4225C3.42111 16.2662 3.33331 16.0543 3.33331 15.8333V14.1666C3.33331 13.9456 3.42111 13.7336 3.57739 13.5773C3.73367 13.421 3.94563 13.3333 4.16665 13.3333Z"
              stroke="#4DC3BD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 10H15.8334C16.0544 10 16.2663 10.0878 16.4226 10.2441C16.5789 10.4004 16.6667 10.6123 16.6667 10.8333V15.8333C16.6667 16.0543 16.5789 16.2663 16.4226 16.4226C16.2663 16.5789 16.0544 16.6667 15.8334 16.6667H12.5C12.279 16.6667 12.067 16.5789 11.9108 16.4226C11.7545 16.2663 11.6667 16.0543 11.6667 15.8333V10.8333C11.6667 10.6123 11.7545 10.4004 11.9108 10.2441C12.067 10.0878 12.279 10 12.5 10Z"
              stroke="#4DC3BD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 3.33325H15.8334C16.0544 3.33325 16.2663 3.42105 16.4226 3.57733C16.5789 3.73361 16.6667 3.94557 16.6667 4.16659V5.83325C16.6667 6.05427 16.5789 6.26623 16.4226 6.42251C16.2663 6.57879 16.0544 6.66659 15.8334 6.66659H12.5C12.279 6.66659 12.067 6.57879 11.9108 6.42251C11.7545 6.26623 11.6667 6.05427 11.6667 5.83325V4.16659C11.6667 3.94557 11.7545 3.73361 11.9108 3.57733C12.067 3.42105 12.279 3.33325 12.5 3.33325Z"
              stroke="#4DC3BD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_17657_21429">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <label class="title">Dashboard</label>
      </div> -->

      <!-- <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="cursor: pointer"
      >
        <path
          d="M15.629 12.3743L15.2367 12.7666L14.8436 12.3743C14.3349 11.864 13.6551 11.5831 12.9303 11.5831H12.9287C12.204 11.5831 11.5241 11.864 11.0138 12.3743C10.5035 12.8855 10.2218 13.5653 10.2218 14.29C10.2218 15.0156 10.5035 15.6954 11.0138 16.2032L14.9359 20.1253C15.0157 20.2051 15.1237 20.25 15.2368 20.25C15.3498 20.25 15.4578 20.2051 15.5376 20.1253L19.4589 16.2041C19.9692 15.6963 20.2492 15.0165 20.2492 14.2901C20.2492 13.5645 19.9683 12.8838 19.4597 12.3744C18.4042 11.3189 16.6855 11.318 15.6283 12.3744L15.629 12.3743ZM18.8587 15.6015L15.2369 19.2228L11.615 15.6009C11.2659 15.2527 11.0731 14.7872 11.0731 14.2894C11.0731 13.7924 11.2659 13.3253 11.6158 12.9754C11.9649 12.6264 12.432 12.4335 12.929 12.4335H12.9298C13.4268 12.4335 13.8922 12.6263 14.2413 12.9754L14.9361 13.6686C15.1023 13.8348 15.3716 13.8339 15.5378 13.6686L16.231 12.9754C16.9557 12.2507 18.1342 12.2515 18.859 12.9754C19.2081 13.3245 19.3992 13.7907 19.3992 14.2894C19.3992 14.7881 19.2073 15.2535 18.859 15.6009L18.8587 15.6015ZM7.13014 4.9342L5.00499 8.26289C4.92853 8.38257 4.79888 8.45571 4.65676 8.45903H4.64596C4.50799 8.45903 4.37917 8.39254 4.29855 8.27951L3.01948 6.47851C2.88318 6.28736 2.92806 6.02141 3.12005 5.88509C3.31203 5.74879 3.57715 5.79367 3.71347 5.98566L4.62686 7.27139L6.41208 4.47461C6.5384 4.27681 6.80186 4.21863 6.99967 4.34496C7.19747 4.47129 7.25564 4.73474 7.12932 4.93255L7.13014 4.9342ZM7.13014 10.3563L5.00499 13.685C4.92853 13.8046 4.79888 13.8778 4.65676 13.8811H4.64596C4.50799 13.8811 4.37917 13.8146 4.29855 13.7016L3.01948 11.9006C2.88318 11.7094 2.92806 11.4435 3.12005 11.3072C3.31203 11.1709 3.57715 11.2157 3.71347 11.4077L4.62686 12.6935L6.41208 9.89668C6.5384 9.69887 6.80186 9.6407 6.99967 9.76702C7.19747 9.89335 7.25564 10.1568 7.12932 10.3546L7.13014 10.3563ZM20.25 3.24039V10.2499C20.25 10.4851 20.0597 10.6754 19.8245 10.6754C19.5893 10.6754 19.3989 10.4851 19.3989 10.2499V3.24039C19.3989 2.06104 18.4398 1.10105 17.2596 1.10105H3.24039C2.06104 1.10105 1.10105 2.06098 1.10105 3.24039V17.2596C1.10105 18.4389 2.06098 19.3989 3.24039 19.3989H10.3048C10.54 19.3989 10.7303 19.5893 10.7303 19.8245C10.7303 20.0597 10.54 20.25 10.3048 20.25H3.24039C1.59147 20.25 0.25 18.9086 0.25 17.2596V3.24039C0.25 1.59147 1.59141 0.25 3.24039 0.25H17.2596C18.9085 0.25 20.25 1.59141 20.25 3.24039ZM16.4328 6.53823C16.4328 6.77344 16.2425 6.96376 16.0073 6.96376H10.4929C10.2577 6.96376 10.0673 6.77343 10.0673 6.53823C10.0673 6.30302 10.2577 6.1127 10.4929 6.1127H16.0073C16.2425 6.1127 16.4328 6.30302 16.4328 6.53823ZM16.4037 9.06735C16.4037 9.30256 16.2134 9.49288 15.9782 9.49288H12.8182C12.583 9.49288 12.3927 9.30255 12.3927 9.06735C12.3927 8.83214 12.583 8.64182 12.8182 8.64182H15.9782C16.2134 8.64182 16.4037 8.83215 16.4037 9.06735Z"
          fill="#4DC3BD"
          stroke="#4DC3BD"
          stroke-width="0.5"
        />
      </svg> -->
    </div>

    <div class="profile-group">
      <i
        aria-label="Document Center"
        type="button"
        (click)="OpenOnboardingOverview()"
        class="ti ti-file-description fs-22"
        [ngbTooltip]="'Document Center'"
        style="color: #abb9ca"
      ></i>
      <i
        aria-label="Referral link"
        type="button"
        (click)="openHomeHealthConsent()"
        class="ti ti-link fs-22"
        [ngbTooltip]="'Referral link'"
        style="color: #abb9ca"
      ></i>
      <div class="topbar-item">
        <button
          ngbDropdownToggle
          class="topbar-link topbar-link-button drop-arrow-none"
          data-bs-toggle="dropdown"
          data-bs-offset="0,25"
          type="button"
          data-bs-auto-close="outside"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <i class="ti ti-bell animate-ring fs-22"></i>
          <span class="noti-icon-badge"></span>
        </button>
      </div>

      <div class="topbar-item nav-user">
        <div class="topbar-link drop-arrow-none">
          <ng-container
            *ngIf="this.userSettings.userInfo.imagePath; else avatarTemplate"
          >
            <img
              [src]="this.userSettings.userInfo.imagePath"
              alt="user-image"
              class="rounded-circle me-lg-2 d-flex user-avatar-img"
              style="cursor: pointer"
              (click)="settingMenu()"
            />
          </ng-container>
          <ng-template #avatarTemplate>
            <div
              class="rounded-circle me-lg-2 d-flex user-avatar-initials"
              (click)="settingMenu()"
            >
              {{
                getInitials(
                  this.userSettings.userInfo.first_name,
                  this.userSettings.userInfo.last_name
                )
              }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</header>
